import { Box, VStack } from 'native-base';
import React, { useCallback } from 'react';

import PurchasesTripsList from 'app/components/PurchasesTripsList';
import Screen from 'app/components/Screen';
import useGuestDataRefreshControl from 'app/hooks/useGuestDataRefreshControl';
import useMetaData from 'app/hooks/useMetaData';
import { PurchasesStackParamList } from 'app/navigation/PurchasesStackNavigator';
import { RootScreenProps } from 'app/navigation/RootNavigator';
import { tID } from 'app/services/TestHelper';

export type PastTripsScreenProps = RootScreenProps<PurchasesStackParamList, 'PastTrips'>;

export default function PastTripsScreen({ navigation }: PastTripsScreenProps) {
  useMetaData('Purchases');
  const { guestDataRefreshControl, guestDataUpdatedAt } = useGuestDataRefreshControl();

  const handleOrderDetailsOpen = useCallback(
    (entitlementKey: string) => {
      navigation.navigate('PurchasesStack', {
        screen: 'PurchaseOrderDetails',
        params: { entitlementKey },
      });
    },
    [navigation]
  );

  return (
    <Screen refreshControl={guestDataRefreshControl} testID={tID('PastTripsScreen')}>
      <Box testID={tID('PastTripsList')}>
        <VStack pb="2" space="6">
          <PurchasesTripsList
            fadePastTrips={false}
            showAllPastTrips
            showMyTrips={false}
            showPastTripsHeading={false}
            onViewOrderDetails={handleOrderDetailsOpen}
          />
          <VStack space="0">{guestDataUpdatedAt}</VStack>
        </VStack>
      </Box>
    </Screen>
  );
}
